import React, { useState } from "react";
import "./HistoricalReport.css";
import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";
import Sidebar from "../components/Sidebar/Sidebar";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { DataLoader } from "../utils/DataLoader";
import * as AiIcons from "react-icons/ai";
import * as FiIcons from "react-icons/fi";
import { ReportFilter } from "../components/SearchFilter/ReportFilter";

export default function HistoricalReports() {
  const ControllerNActionName = {
    ControllerName: "Reports",
    ActionName: "gethistoricalreports",
    SearchField: "search_text",
  };
  const [orders, setOrders] = useState({
    data: [],
    total: 0,
  });
  //const [searchText, setSearchText] = useState(null);
  const [dataState, setDataState] = useState({
    take: 50,
    skip: 0,
    filter: "0",
  });

  const dataStateChange = (e) => {
    // console.log(e.dataState);
    setDataState(e.dataState);
  };
  const dataReceived = (orders) => {
    //  console.log(orders);
    setOrders(orders);
  };
  const initialSort = [
    {
      field: "order_report_mapping_id",
      dir: "desc",
    },
  ];
  const [count, setCount] = useState(1);
  const [sort, setSort] = React.useState(initialSort);

  const handleSearch = async (searchValue) => {
    localStorage.setItem("searchData", true);
    setDataState({ take: 50, skip: 0, filter: searchValue });
  };

  const handleSorting = (e) => {
    //console.log(e);
    localStorage.setItem("sortData", true);
    let sortingArray = e.sort;
    sortingArray.forEach((element, i) => {
      if (element.field === "id") {
        e.sort[i].field = "order_report_mapping_id";
        e.sort[i].dir = count % 2 == 0 ? "desc" : "asc";
      } else if (element.field === "reportName") {
        e.sort[i].field = "report_name";
        e.sort[i].dir = count % 2 == 0 ? "desc" : "asc";
      } else if (element.field === "templateName") {
        e.sort[i].field = "template_name";
        e.sort[i].dir = count % 2 == 0 ? "desc" : "asc";
      }
    });
    setCount(count + 1);
    setSort(e.sort);
  };

  return (
    <>
      <Container>
        <Row className="page-head-row">
          <Col lg={6} md={6} sm={12}>
            <div className="page-title">
              <h2>Historical Reports</h2>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="search-filter">
              <ReportFilter
                search={handleSearch}
                advSearch={null}
                searchPlaceHolder="Search by report/template name"
                displayShort={false}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Grid
            sortable={true}
            sort={sort}
            onSortChange={(e) => {
              handleSorting(e);
            }}
            pageable={true}
            {...dataState}
            data={orders}
            onDataStateChange={dataStateChange}
            style={{ height: "75vh" }}
          >
            <GridColumn
              field="order_report_mapping_id"
              title="ID"
              width="100px"
            />
            <GridColumn field="report_name" title="Report Name" />
            <GridColumn field="template_name" title="Template Name" />
            <GridColumn
              sortable={false}
              field="id"
              title="Action"
              width="150px"
              cell={(props) => (
                <td className="act">
                  <a
                    href={`/Report?type=historic_view&id=${props.dataItem.order_report_mapping_id}`}
                    className="orderAction"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <AiIcons.AiOutlineEye />
                  </a>
                  &nbsp;&nbsp;
                  <a
                    href={`/Report?type=historic_view_download&id=${props.dataItem.order_report_mapping_id}&reportname=${props.dataItem.template_name}`}
                    className="orderAction"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FiIcons.FiDownload />
                  </a>
                </td>
              )}
            ></GridColumn>
          </Grid>
          <DataLoader
            dataState={dataState}
            onDataReceived={dataReceived}
            dataItem={ControllerNActionName}
            dataSort={sort}
          />
        </Row>
      </Container>
    </>
  );
}
